<template>
  <v-navigation-drawer
    v-if="isUserValid && isAdmin() && !isAdminDraftView && !isPreferencesView"
    width="400"
    location="right"
    touchless="touchless"
    v-model="showPageHistoryNav"
    style="overflow-y: auto"
    id="page-history--nav-draw"
  >
    <v-btn
      id="page-history--close-button"
      class="float-right ma-2"
      icon="mdi-close"
      variant="text"
      @click="showPageHistoryNav = false"
      color="rgba(0, 0, 0, 0.54)"
    >
    </v-btn>
    <div class="d-flex flex-column app-side-nav-container">
      <div class="text-center mt-3">
        <v-list-item-title><b>PAGE HISTORY</b></v-list-item-title>

        <v-list-item-subtitle v-if="!pageHistoryEvents.length"
          >There is no history available for this page.</v-list-item-subtitle
        >

        <template v-if="pageHistoryEvents.length">
          <v-container style="max-width: 400px">
            <cs-button
              id="getCurrentContentBtn"
              class="mb-4"
              label="Return to Current Version"
              @click="getCurrentContentVersion()"
              primary
              large
            ></cs-button>
            <v-timeline density="compact" clipped>
              <v-slide-x-transition group>
                <v-timeline-item
                  v-for="(event, index) in pageHistoryEvents"
                  :key="event.id"
                  class="mb-4"
                  size="small"
                  dot-color="primary"
                >
                  <v-row
                    :class="[
                      'd-flex',
                      'flex-row',
                      'justify-space-between',
                      'page-history-event',
                      index !== 0 ? 'clickable' : 'non-clickable',
                      event.id == pageCommitOID() ? 'selected' : ''
                    ]"
                    @click="index !== 0 && getPreviousContentVersion(event)"
                  >
                    <v-col cols="8">
                      <span
                        class="text-break page-history-summary"
                        :title="event.publishSummary || 'Module Published'"
                        >{{ event.publishSummary || 'Module Published' }}</span
                      >
                    </v-col>
                    <v-col
                      class="text-right"
                      cols="4"
                      v-text="convertDateFormat(event.date)"
                    ></v-col>
                  </v-row>
                </v-timeline-item>
              </v-slide-x-transition>
            </v-timeline>
          </v-container>
        </template>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import moment from 'moment-timezone';
import { CSBase } from '@complispace/cs-design-system';
import * as types from '@/store/mutationTypes';
import EventBus from '@/bus';
import { EVENTBUS_CMD } from '@/constants';

export default {
  name: 'PageHistory',

  extends: CSBase,

  computed: {
    ...mapState({
      isPreferencesView: (state) => state.appearance.isPreferencesView,
      viewType: (state) => state.authorisation.viewType,
      pageHistoryEvents: (state) => state.data.pageHistory
    }),

    ...mapGetters({
      isUserValid: 'authorisation/isUserValid',
      hasAccess: 'authorisation/hasAccess',
      isAdminDraftView: 'authorisation/isAdminDraftView',
      role: 'authorisation/role',
      pageCommitOID: 'data/getPageCommitOID'
    }),

    showPageHistoryNav: {
      get() {
        return this.$store.state.appearance.showPageHistoryNav;
      },

      set(value) {
        this.setPageHistoryNav(value);
      }
    }
  },

  watch: {
    $route() {
      this.setPageHistoryNav(false);
    },

    async viewType() {
      this.setPageHistoryNav(false);
    }
  },

  methods: {
    ...mapMutations({
      setPageHistoryNav: types.APPEARANCE_SET_PAGE_HISTORY_NAV,
      setPageCommitOID: types.DATA_SET_PAGE_COMMIT_OID,
      setPageCommitTimestamp: types.DATA_SET_PAGE_COMMIT_TIMESTAMP
    }),

    showPageHistory() {
      this.setPageHistoryNav(true);
    },

    isAdmin() {
      const roleId = parseInt(this.role, 10);
      if (roleId === 4 || roleId === 3 || roleId === 2) {
        return true;
      }
      return false;
    },

    getPreviousContentVersion(event) {
      const { id, date } = event;

      this.setPageCommitOID(id);
      this.setPageCommitTimestamp(date);
    },

    getCurrentContentVersion() {
      EventBus.$emit(EVENTBUS_CMD.HARD_REFRESH);
      this.setPageHistoryNav(false);
      this.setPageCommitOID('');
      this.setPageCommitTimestamp('');
    },

    convertDateFormat(date) {
      return moment
        .tz(date, 'Australia/Sydney')
        .format('DD/MM/YYYY HH:mm:ss')
        .replace(/:[^:]*$/, '');
    }
  }
};
</script>

<style scoped>
#page-history--nav-draw .app-side-nav-container {
  position: absolute;
}

#page-history--nav-draw #page-history--close-button {
  z-index: 1;
}
.page-history-event {
  width: 300px;
}

.page-history-event.clickable:hover {
  cursor: pointer;
  text-decoration: underline;
}

.page-history-event.clickable:hover .page-history-summary {
  cursor: pointer;
  text-decoration: underline;
}

.page-history-event.non-clickable {
  color: rgba(0, 0, 0, 0.38);
}
.page-history-event.selected {
  color: rgb(var(--v-theme-primary));
  font-weight: 700;
}

.page-history-summary {
  width: 100%;
  overflow: hidden;
  position: relative;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
